/*
 *
 * Package: `@dbh/text-theme`.
 *
 */const TEXT_THEME_KEY="textTheme";const modifyTextTheme=a=>{let{colors:{black:b}}=a;return {[TEXT_THEME_KEY]:{textShadow:"0px 1px 6px "+b}}};

export { TEXT_THEME_KEY, modifyTextTheme as default };
